import { FC } from 'react'
import { SignInForm } from './components/SignInForm/SignInForm'

type TProps = {}

const SignInPageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col">
      <SignInForm />
    </div>
  )
}

export { SignInPageContent }
